import api from 'Application/api/api';

const getPendingMeasureTasks = (cancelToken = null) =>
    api.get('/measures/tasks/pending', { cancelToken });

export default getPendingMeasureTasks;
